import Layout from '@layout/Index'

export const customerProjectReport = [
  {
    path: '/customer-project-report',
    component: Layout,
    children: [
      {
        path: 'table/:customerid',
        component: () => import(/* webpackChunkName: "CustomerProjectTable" */ './pages/CustomerProjectReportTable.vue'),
        name: '项目报告列表',
        meta: {
          title: '项目报告列表',
        },
      },
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/customer-project-report/customer-project-report.route.js